module.exports = __webpack_public_path__ + "img/subject4_09_106.jpg";